var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"container"}},[_c('core-header'),_c('core-mainnav'),_c('core-view'),_c('core-footer'),(_vm.loggedIn)?[_c('core-timeout')]:_vm._e(),_c('core-refresh')],2)}
var staticRenderFns = []

export { render, staticRenderFns }